import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import payment from '../../img/payment.png';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const PaymentSuccess = () => {
  const query = useQuery();
  const [orderId, setOrderId] = useState('');

  useEffect(() => {
    setOrderId(query.get('order_id') || '');
  }, [query]);

  return (
    <div className="main-container section-container page-wraper success-msg">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-9">
            <div className="form-wrap text-center py-5">
              <div className="img-container">
                <img src={payment} width="120" alt="Payment successful" />
              </div>
              <h3>Payment successful</h3>
              <p>Thank you. Your subscription payment has been received.</p>
              {orderId && <p className="text-muted">Order ID: {orderId}</p>}
              <Link to="/subscription-management" className="btn btn-primary w-auto me-2">
                Subscription management
              </Link>
              <Link to="/subscription-management" className="btn btn-outline-secondary w-auto">
                Continue
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
